import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';
import { StyledCell } from 'views/root/views/home/views/projects/ResourceAllocationOverview/JiraStats/useTableRows/Row.style';

const StyledIssueTypeCell = styled(StyledCell)`
  & > img {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const IssueTypeCell = ({ name, icon }) => {
  return (
    <StyledIssueTypeCell>
      <Tooltip title={name} placement='top'>
        <img src={icon} />
      </Tooltip>
    </StyledIssueTypeCell>
  );
};

export default IssueTypeCell;
